(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/assets/react/app.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/assets/react/app.js');

'use strict';

const Router = svs.lyckoplatsen.react.Router;
const App = () => React.createElement(React.StrictMode, null, React.createElement(Router, null));
const target = document.getElementById('lyckoplatsen');
target && ReactDOM.render(React.createElement(App, null), target);

 })(window);